// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8201 ? "media" : chunkId) + "." + {"423":"8247dd91f9c0dd9b","2375":"23912fca016ee5bb","2980":"99b7c2b2f08ba37f","6797":"8ab861dd05984d0b","8201":"08bd04246a4b99eb","8496":"f608f58dce8de4ec"}[chunkId] + ".js";
};